import {useTranslation} from '@/translations/i18n'
import {AlertCircleIcon} from '@/components/ui/icon/Icon'
import {useOutletContext} from 'react-router-dom'
import {ProjectExtended} from '@/features/projects/types'
import {ErrorBox} from '@/components/commons/error-box/ErrorBox'
import {PlannedAccessCard} from '../planned-access-card/PlannedAccessCard'
import {PlannedAccessEmptyCard} from '../planned-access-empty-card/PlannedAccessEmptyCard'
import {useGetPlannedAccessesDetails} from '@/features/planned-accesses/queries/useGetPlannedAccessesDetails'

export const PlannedAccessSection = () => {
    const {project} = useOutletContext<{project: ProjectExtended}>()
    const {t} = useTranslation()
    const {
        data: plannedAccesses,
        isLoading: isLoadingPlannedAccesses,
        isError: isErrorPlannedAccesses,
        error: errorPlannedAccesses
    } = useGetPlannedAccessesDetails({
        urlParams: {
            projectId: project.id
        }
    })
    return isErrorPlannedAccesses &&
        errorPlannedAccesses?.response?.data.code !== 'project-planned-access-not-found' ? (
        <ErrorBox icon={<AlertCircleIcon />} title={t('errors:default')} />
    ) : plannedAccesses ? (
        <PlannedAccessCard plannedAccesses={plannedAccesses} />
    ) : (
        <PlannedAccessEmptyCard isLoading={isLoadingPlannedAccesses} />
    )
}
